import axios from 'axios'
import { parseJwt } from '@/utils/utils'
import { getStorage } from '@/utils/storageUtil'

// 訪問地址：
// http://具體服務器地址/check-in/services/getEnrolledProposalClassList
// 請求⽅式：http get
// status：0 成功，1 失敗
// msg：描述消息，返回錯誤原因，或成功信息。
// datas：該學員⼀年內的已錄取的課程List，補讀個別單元的課程也包含其中。
// 其中包含欄位
// classSeqNum：課程編號
// nameZH：課程中⽂名
// namePT：課程葡⽂名
// startDate：課程開始⽇期
// endDate：課程結束⽇期
// hours：課時
// maxAbsence：可缺席時數
// attendancePercentage：出席率
// qualifiedLimit：合格分數
// classAddress:上課地點
// API 說明：
// 這裏的⼀年內是通過查找proposalClass表中的StartDate和EndDate，當startDate早於等於今天且
// endDate晚於等於⼀年前的今天。
// 補讀⽣的情況，只看整個ProposalClass的開始⽇期和結束⽇期與⼀年內有交集。即使這個單元上
// 課時間不在⼀年範圍內，也會返回這個單元所屬的課程。

// 訪問地址：
// http://具體服務器地址/check-in/services/proposalClassSignRecord/課程編號
// status：0 成功，1 錯誤
// message：描述消息，返回錯誤原因，或成功信息。
// datas：該學員需要上的堂課的信息和其簽到記錄，如果是補讀個別單元的，則只返回其補讀單元
// 所要上的堂和簽到記錄。
// 其中包含欄位
// date ：⽇期
// sectionTime：第⼀節時間字符串
// sectionTime2：第⼆節時間字符串，如無則為單節堂
// unitProposalClassId：如果該課程為單元制課程，該堂所屬的單元id
// unitTitle：如果該課程為單元制課程，該堂所屬的單元標題
// unitDescription：如果該課程為單元制課程，該堂所屬的單元描述
// isNeedClassOverSign：true為該堂需要下課簽到，false則不需要
// time：第⼀節上課簽到時間字符串，形式為”09:00”
// time2：第⼀節下課簽到時間字符串，形式為”10:00”
// time3：第⼆節上課簽到時間字符串，形式為”14:00”
// time4：第⼆節下課簽到時間字符串，形式為”15:00”
// status1：第⼀節上課簽到標識字符串 GENERAL為正常簽到, LATE為遲到, LEAVE_EARLY為早
// 退，ABSENT爲缺席，WAITING爲等待簽到，NO_NEED_SIGN爲無需簽到。詳細status邏輯可
// 查看下⽂中status狀態表格。
// status2：第⼀節下課簽退標識字符串
// status3：第⼆節上課簽到標識字符串
// status4：第⼆節下課簽退標識字符串

const baseUrl = '/check-in/services/'
const classListUrl = baseUrl + 'getEnrolledProposalClassList'
const classSignRecordUrl = baseUrl + 'proposalClassSignRecord/' // + class Id

function getAxiosConfig () {
  const token = parseJwt(getStorage('g2e-jwt-token')).access_token
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Mo-Gov-Account-Type': 'Gov-Entity',
      'Mo-Gov-Account-Lang': 'zh-TW'
    }
  }
}

export default {

  getClassList (cb) {
    axios.get(classListUrl, getAxiosConfig()).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getClasssSignRecord (cb, classId) {
    axios.get(classSignRecordUrl + classId, getAxiosConfig()).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  }

}
